import React from 'react';
import { useDashboard } from '../../contexts/DashboardContext';
import {
  PortfolioOverviewTab,
  RiskAssetQualityTab,
  DepositsLiquidityTab,
  PSLRegulatoryTab,
  CustomerInsightsTab
} from './tabs';

const DashboardTabContent = () => {
  const { activeTab } = useDashboard();

  const renderTab = () => {
    switch (activeTab) {
      case 'portfolio':
        return <PortfolioOverviewTab />;
      case 'risk':
        return <RiskAssetQualityTab />;
      case 'deposits':
        return <DepositsLiquidityTab />;
      case 'psl':
        return <PSLRegulatoryTab />;
      case 'customers':
        return <CustomerInsightsTab />;
      default:
        return <PortfolioOverviewTab />;
    }
  };

  return (
    <div className="mb-6">
      {renderTab()}
    </div>
  );
};

export default DashboardTabContent;
